import React from 'react';
import { ColumnItem } from '../../components/column-item';
import { toSafeColor } from '../../utils/to-safe-color';
export var ItemPrice = function (_a) {
    var _b;
    var section = _a.section, item = _a.item;
    if (((_b = section.show) === null || _b === void 0 ? void 0 : _b.price) === false) {
        return null;
    }
    return (React.createElement(ColumnItem, { align: section.price.align, padding: "0px" },
        React.createElement("div", { style: {
                fontFamily: section.price.fontFamily,
                fontSize: section.price.fontSize,
                fontStyle: section.price.fontStyle,
                fontWeight: section.price.fontWeight || undefined,
                lineHeight: section.price.lineHeight,
                textAlign: section.price.align,
                textDecoration: section.price.textDecoration,
                color: toSafeColor(section.price.color),
                whiteSpace: 'pre-wrap',
            } },
            item.discountedPrice,
            item.discountedPrice !== item.price && (React.createElement(React.Fragment, null,
                "\u00A0",
                React.createElement("span", { style: { textDecoration: 'line-through' } }, item.price))))));
};
//# sourceMappingURL=item-price.js.map